import React, { useEffect, useRef, useState } from "react";
import { SURVEY_JS_ENDPOINT } from "../config";
import BotService from "../services/botService";

// @ts-ignore
const eventMethod: string = window.addEventListener
	? "addEventListener"
	: "attachEvent";
// @ts-ignore
const eventer: any = window[eventMethod];
const messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";

interface IFrameWrapperProps {
	onMessage?: (messageType: string, data?: any) => void;
	onClose?: () => void;
	title?: string;
	headers?: Array<[string, string]>;
	formData?: any;
	botService?: BotService;
}

const IFrameWrapper: React.FC<IFrameWrapperProps> = ({
	onMessage,
	onClose,
	title = "Form",
	headers,
	formData,
	botService,
}) => {
	const url: any = SURVEY_JS_ENDPOINT;

	const iframeRef = useRef<HTMLIFrameElement>(null);
	const [loading, setLoading] = useState<boolean>(true);
	const [iframeSrc, setIframeSrc] = useState<string | undefined>();

	useEffect(() => {
		// Setup message listener for iframe communication
		const messageHandler = (event: MessageEvent) => {
			const data = event.data;

			if (data === "Submitted") {
				onMessage && onMessage("Submitted", { url });
			} else if (typeof data === "object" && data !== null) {
				switch (data.type) {
					case "changeUrl":
						window.location.href = data.value;
						break;
					case "complete":
						onMessage && onMessage("complete", { url, data });
						break;
					case "updated":
						onMessage && onMessage("updated", { url, data });
						break;
				}
			}
		};

		eventer(messageEvent, messageHandler, false);

		// Only fetch if we have headers and no iframeSrc yet
		if (headers && headers.length > 0 && url && !iframeSrc) {
			fetchContentAsBlob();
		}

		return () => {
			const removeMethod =
				eventMethod === "addEventListener"
					? "removeEventListener"
					: "detachEvent";
			// @ts-ignore
			window[removeMethod](messageEvent, messageHandler, false);

			// Cleanup blob URL if it exists
			if (iframeSrc && iframeSrc.startsWith("blob:")) {
				URL.revokeObjectURL(iframeSrc);
			}
		};
	}, [headers, onMessage, url, iframeSrc]);

	const handleIframeLoad = () => {
		setLoading(false);
	};

	const fetchContentAsBlob = async () => {
		try {
			setLoading(true);

			let params = "";
			if (formData) {
				params = `formId=${formData.formId}&answers=${encodeURIComponent(
					typeof formData.answers === "string"
						? formData.answers
						: JSON.stringify(formData.answers)
				)}&opt=${formData.opt || 0}`;
			}

			const xhr = new XMLHttpRequest();
			xhr.open("POST", url);
			xhr.withCredentials = true;
			xhr.responseType = "blob";
			xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

			if (headers) {
				headers.forEach(function (header) {
					xhr.setRequestHeader(header[0], header[1]);
				});
			}

			xhr.onreadystatechange = function () {
				if (xhr.readyState === XMLHttpRequest.DONE) {
					if (xhr.status === 200) {
						console.log("Request successful with status 200");
						const blobUrl = URL.createObjectURL(xhr.response);
						setIframeSrc(blobUrl);
					} else {
						// console.error("Request failed with status:", xhr.status);
						if (botService) {
							if (botService) {
								botService
									.sendMessage("unauthorized", "event")
									.catch((error) =>
										console.error("Error sending unauthorized event:", error)
									);
							}
						}
						setLoading(false);
					}
				}
			};

			xhr.send(params);
		} catch (error) {
			setLoading(false);
		}
	};

	return (
		<div className="iframe-container">
			{title && (
				<div className="iframe-header">
					<h3>{title}</h3>
					{onClose && (
						<button
							className="close-iframe-btn"
							onClick={onClose}
							style={{
								position: "absolute",
								top: "70px",
								right: "10px",
								zIndex: 20,
								background: "#000",
								color: "#fff",
								border: "none",
								borderRadius: "50%",
								width: "30px",
								height: "30px",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								cursor: "pointer",
							}}
						>
							✕
						</button>
					)}
				</div>
			)}

			<div className="iframe-content">
				{loading && (
					<div className="iframe-loading-overlay">
						<div className="loader"></div>
					</div>
				)}
				{iframeSrc && (
					<iframe
						ref={iframeRef}
						src={iframeSrc}
						className="referral-iframe"
						onLoad={handleIframeLoad}
						title="External Content"
					/>
				)}
			</div>
		</div>
	);
};

export default IFrameWrapper;
